var _g, _g2, _ellipse, _rect, _rect2, _rect3, _ellipse2, _g3, _rect4, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _path18, _ellipse3, _path19, _path20, _path21, _path22, _ellipse4, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_32670)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_i_1727_32670)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.559 66.1122C162.81 58.9003 181.53 60.5259 188.752 61.2217C195.973 61.9174 196.629 52.0377 190.398 50.5691C184.168 49.1005 172.869 49.8584 167.015 48.5028C161.16 47.1472 168.566 39.877 160.589 39.0006C152.612 38.1244 136.119 38.9357 131.202 38.7576C123.478 38.478 119.516 47.8109 133.047 48.2344C136.778 48.3511 137.527 56.6423 124.931 54.3648C117.027 52.9356 101.519 52.9026 98.2931 56.5515C96.4421 58.6451 97.0835 64.2698 100.266 67.3757C102.63 69.6829 110.147 70.1328 113.092 70.6661C120.001 71.9175 118.636 78.6323 116.28 80.0149C110.705 83.2866 95.4046 77.112 94.9945 86.096C94.8132 90.066 108.735 90.7069 114.443 90.6584C128.443 90.5396 137.641 91.7916 138.287 86.998C138.935 82.1857 129.587 85.4338 130.048 79.5177C130.289 76.4262 129.643 69.857 135.641 70.2018C127.43 69.7297 162.221 75.8526 162.559 66.1122Z",
    fill: "url(#paint0_linear_1727_32670)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_i_1727_32670)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5028 37.9449C77.4842 30.7286 96.2523 31.6496 103.495 32.0734C110.737 32.4973 111.024 22.5998 104.743 21.3664C98.4615 20.133 87.1989 21.315 81.2983 20.1804C75.3976 19.0458 82.5265 11.5023 74.5227 10.9264C66.519 10.3505 50.0672 11.7811 45.1469 11.788C37.4185 11.7989 33.8068 21.2741 47.3442 21.1888C51.0773 21.1653 52.1347 29.4224 39.4632 27.6199C31.5113 26.4888 16.0129 27.0386 12.9252 30.8062C11.1536 32.9679 12.0044 38.5645 15.3002 41.5486C17.7485 43.7655 25.2777 43.9324 28.2405 44.3548C35.1914 45.3455 34.077 52.107 31.7744 53.5771C26.3255 57.0561 10.8056 51.4608 10.7309 60.454C10.6979 64.428 24.6334 64.5453 30.3358 64.2823C44.3215 63.6373 53.5603 64.5427 54.0265 59.7283C54.4946 54.8949 45.2746 58.4921 45.5145 52.5628C45.6399 49.4644 44.7498 42.9241 50.7557 43.0433C42.533 42.8801 77.5279 47.6912 77.5028 37.9449Z",
    fill: "url(#paint1_linear_1727_32670)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.084933,
    rx: 16.876,
    ry: 0.957025,
    transform: "matrix(-1 0 0 1 28.9795 165.804)",
    fill: "#8699BF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.776 164.804C183.41 164.412 198.397 157.844 197.013 156.438C195.629 155.033 188.879 155.033 188.879 155.033C188.879 155.033 182.143 165.197 182.776 164.804Z",
    fill: "url(#paint2_linear_1727_32670)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86.3823,
    height: 160.015,
    rx: 43.1912,
    transform: "matrix(-1 0 0 1 129.379 11.7227)",
    fill: "url(#paint3_linear_1727_32670)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 86.3823,
    height: 160.015,
    rx: 43.1912,
    transform: "matrix(-1 0 0 1 136.436 11.7227)",
    fill: "url(#paint4_linear_1727_32670)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45.3841,
    height: 2.87108,
    rx: 1.43554,
    transform: "matrix(-1 0 0 1 115.84 22.0586)",
    fill: "url(#paint5_linear_1727_32670)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.00896,
    ry: 8.03902,
    transform: "matrix(-1 0 0 1 93.3387 160.253)",
    fill: "url(#paint6_linear_1727_32670)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1727_32670)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79.3268,
    height: 114.077,
    rx: 12,
    transform: "matrix(-1 0 0 1 132.812 34.6914)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 34,
    width: 80,
    height: 115
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 79.3268,
    height: 114.077,
    rx: 12,
    transform: "matrix(-1 0 0 1 132.812 34.6914)",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1727_32670)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.6992,
    height: 21.8202,
    rx: 10.9101,
    transform: "matrix(-1 0 0 1 128.998 122.163)",
    fill: "url(#paint7_linear_1727_32670)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.00896,
    ry: 8.03901,
    transform: "matrix(-1 0 0 1 118.13 133.073)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.4306,
    height: 3.25389,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 125.991)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.9427,
    height: 3.25389,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 131.351)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 12.5855,
    height: 2.29686,
    rx: 1.14843,
    transform: "matrix(-1 0 0 1 107.26 137.858)",
    fill: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.6992,
    height: 21.8202,
    rx: 10.9101,
    transform: "matrix(-1 0 0 1 128.998 95.75)",
    fill: "url(#paint8_linear_1727_32670)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.00896,
    ry: 8.03901,
    transform: "matrix(-1 0 0 1 118.13 106.66)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.4306,
    height: 3.25389,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 99.5781)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.9427,
    height: 3.25388,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 104.938)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 12.5855,
    height: 2.29686,
    rx: 1.14843,
    transform: "matrix(-1 0 0 1 107.26 111.445)",
    fill: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.6992,
    height: 21.8202,
    rx: 10.9101,
    transform: "matrix(-1 0 0 1 128.998 40.625)",
    fill: "url(#paint9_linear_1727_32670)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.00896,
    ry: 8.03901,
    transform: "matrix(-1 0 0 1 118.13 51.5351)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.4306,
    height: 3.25388,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 44.4531)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.9427,
    height: 3.25388,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 107.26 49.8125)",
    fill: "#A1B8E3"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 12.5855,
    height: 2.29686,
    rx: 1.14843,
    transform: "matrix(-1 0 0 1 107.26 56.3203)",
    fill: "#A1B8E3"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1727_32670)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.6992,
    height: 21.8202,
    rx: 10.9101,
    transform: "matrix(-1 0 0 1 140.439 66.4648)",
    fill: "url(#paint10_linear_1727_32670)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.00896,
    ry: 8.03901,
    transform: "matrix(-1 0 0 1 129.571 77.3749)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44.4306,
    height: 3.25389,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 118.701 70.293)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.9427,
    height: 3.25389,
    rx: 1.62694,
    transform: "matrix(-1 0 0 1 118.701 75.6523)",
    fill: "#FFB417"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 12.5855,
    height: 2.29686,
    rx: 1.14843,
    transform: "matrix(-1 0 0 1 118.701 82.1602)",
    fill: "#FFB417"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.634 108.038C164.634 111.458 167.44 118.161 163.78 119.899C160.12 121.636 156.884 112.611 156.884 112.611C156.884 112.611 157.163 105.983 160.472 105.983C163.78 105.983 164.634 104.617 164.634 108.038Z",
    fill: "url(#paint11_linear_1727_32670)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 105,
    width: 10,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.634 108.038C164.634 111.458 167.44 118.161 163.78 119.899C160.12 121.636 156.884 112.611 156.884 112.611C156.884 112.611 157.163 105.983 160.472 105.983C163.78 105.983 164.634 104.617 164.634 108.038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1727_32670)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.843 109.57C164.547 110.172 160.525 113.357 159.86 114.11C159.195 114.863 159.043 116.831 158.661 116.628C158.279 116.424 158.661 110.65 158.661 110.65C158.661 110.65 165.138 108.968 164.843 109.57Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.087 185.591C158.149 187.357 158.68 189.548 158.256 190.442C157.832 191.335 155.594 191.875 154.851 191.901C154.108 191.927 153.815 190.677 152.683 191.365C151.551 192.053 144.969 192.247 144.451 189.635C143.932 187.024 147.268 186.907 148.751 186.855C150.235 186.803 151.781 186.022 153.919 184.062C156.056 182.101 158.026 183.824 158.087 185.591Z",
    fill: "url(#paint12_linear_1727_32670)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.804 188.148C149.412 187.268 150.479 186.249 150.75 186.216",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.016 188.125C147.888 187.073 148.626 186.705 148.921 186.668",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.119 189.307C124.965 191.068 125.227 193.308 124.697 194.142C124.168 194.977 121.881 195.24 121.14 195.174C120.399 195.109 120.261 193.833 119.054 194.378C117.847 194.922 111.29 194.31 111.092 191.654C110.895 188.998 114.22 189.29 115.699 189.419C117.178 189.549 118.807 188.964 121.167 187.279C123.527 185.595 125.272 187.546 125.119 189.307Z",
    fill: "url(#paint13_linear_1727_32670)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.586 190.833C116.305 189.911 117.487 189.03 117.76 189.03",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.816 190.591C114.816 189.532 115.593 189.256 115.891 189.256",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.099 126.04C131.099 126.04 123.91 152.477 122.974 158.493C122.039 164.509 119.748 184.842 120.072 188.122C121.636 189.723 124.454 188.764 124.945 188.471C125.436 188.177 128.461 171.447 131.099 164.957C133.738 158.467 139.675 152.494 143.588 145.964C143.588 150.214 146.609 161.588 146.609 161.588C146.609 161.588 151.014 181.673 152.514 184.924C153.225 186.077 156.816 185.231 158.209 184.924C158.209 181.877 155.206 166.487 155.206 161.145C155.206 155.802 156.036 146.119 156.347 142.15C156.657 138.181 157.415 130.48 156.347 126.04C153.638 126.04 131.099 126.04 131.099 126.04Z",
    fill: "url(#paint14_linear_1727_32670)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 126,
    width: 39,
    height: 64
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.099 126.04C131.099 126.04 123.91 152.477 122.974 158.493C122.039 164.509 119.748 184.842 120.072 188.122C121.636 189.723 124.454 188.764 124.945 188.471C125.436 188.177 128.461 171.447 131.099 164.957C133.738 158.467 139.675 152.494 143.588 145.964C143.588 150.214 146.609 161.588 146.609 161.588C146.609 161.588 151.014 181.673 152.514 184.924C153.225 186.077 156.816 185.231 158.209 184.924C158.209 181.877 155.206 166.487 155.206 161.145C155.206 155.802 156.036 146.119 156.347 142.15C156.657 138.181 157.415 130.48 156.347 126.04C153.638 126.04 131.099 126.04 131.099 126.04Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1727_32670)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.379 164.675C147.379 162.087 146.051 140.942 145.745 141.81C145.44 142.678 143.064 147.364 143.064 147.364C143.064 147.364 147.379 167.263 147.379 164.675Z",
    fill: "#A1B8E3",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.674 141.822C145.302 143.389 143.87 145.565 143.208 146.862",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.682 130.457C153.001 131.364 146.421 135.225 137.941 133.678C133.752 132.913 131.057 131.913 129.848 130.457C129.848 129.74 130.864 126.723 131.148 125.569C131.432 124.415 156.74 129.346 154.682 130.457Z",
    fill: "url(#paint15_linear_1727_32670)",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.812 69.8428C143.812 69.8428 142.84 71.7315 141.195 72.5334C139.55 73.3352 138.728 73.7275 138.728 73.7275L139.427 76.4507C139.427 76.4507 138.123 80.4553 138.728 81.8054C139.332 83.1555 141.195 84.0525 142.28 85.2563C143.364 86.46 144.367 90.5438 144.367 90.5438H151.514L151.838 85.2563C151.838 85.2563 153.744 77.6265 150.51 73.7275C147.276 69.8286 143.812 69.8428 143.812 69.8428Z",
    fill: "url(#paint16_linear_1727_32670)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 69,
    width: 15,
    height: 22
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.812 69.8428C143.812 69.8428 142.84 71.7315 141.195 72.5334C139.55 73.3352 138.728 73.7275 138.728 73.7275L139.427 76.4507C139.427 76.4507 138.123 80.4553 138.728 81.8054C139.332 83.1555 141.195 84.0525 142.28 85.2563C143.364 86.46 144.367 90.5438 144.367 90.5438H151.514L151.838 85.2563C151.838 85.2563 153.744 77.6265 150.51 73.7275C147.276 69.8286 143.812 69.8428 143.812 69.8428Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1727_32670)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.389 84.5377C143.193 84.5377 146.007 82.9341 146.549 82.3863C147.091 81.8384 142.039 87.7654 142.46 88.7094C142.793 89.4541 143.981 89.6819 143.232 89.6819C140.53 89.6819 139.584 84.5377 141.389 84.5377Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.838 85.0333C158.141 79.1207 163.131 74.0748 158.827 67.0437C154.523 60.0126 144.509 57.649 142.638 66.1959C142.638 69.8631 145.335 71.8221 145.335 71.8221C145.335 71.8221 145.84 72.8529 144.509 73.9464C143.179 75.0399 144.509 75.9435 144.509 75.9435C144.509 75.9435 147.137 74.2474 147.823 76.5062C148.509 78.765 145.976 79.5735 145.976 80.1389C145.104 82.2167 146.905 84.1173 146.905 84.1173C146.905 84.1173 147.827 85.0333 151.838 85.0333Z",
    fill: "url(#paint17_linear_1727_32670)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.338 93.0088C158.338 93.0088 165.085 104.888 165.899 107.502C166.713 110.116 158.338 111.628 158.338 111.628L154.844 96.6847L158.338 93.0088Z",
    fill: "url(#paint18_linear_1727_32670)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.763 88.9199C143.763 88.9199 138.682 90.2658 135.688 93.8223C132.694 97.3788 133.361 108.079 132.513 114.447C131.665 120.815 127.975 125.444 133.674 129.038C139.374 132.631 155.489 131.815 156.807 129.038C158.125 126.26 159.627 109.188 159.627 109.188C159.627 109.188 159.627 93.8223 157.827 92.527C156.027 91.2318 151.824 88.7285 151.824 88.7285C151.824 88.7285 151.919 89.1094 149.892 89.4868C147.864 89.8643 143.763 88.9199 143.763 88.9199Z",
    fill: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 88,
    width: 30,
    height: 44
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.763 88.9199C143.763 88.9199 138.682 90.2658 135.688 93.8223C132.694 97.3788 133.361 108.079 132.513 114.447C131.665 120.815 127.975 125.444 133.674 129.038C139.374 132.631 155.489 131.815 156.807 129.038C158.125 126.26 159.627 109.188 159.627 109.188C159.627 109.188 159.627 93.8223 157.827 92.527C156.027 91.2318 151.824 88.7285 151.824 88.7285C151.824 88.7285 151.919 89.1094 149.892 89.4868C147.864 89.8643 143.763 88.9199 143.763 88.9199Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1727_32670)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.543 101.075C139.543 101.075 136.802 113.934 135.153 116.344C133.504 118.755 132.431 126.048 131.111 126.918C129.791 127.787 127.895 117.838 128.843 114.432C129.791 111.025 134.065 102.682 134.065 102.682L139.543 101.075Z",
    fill: "url(#paint19_linear_1727_32670)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.616 89.6096C149.396 90.4217 146.218 90.8612 143.547 90.8612C140.875 90.8612 140.04 90.8896 138.761 90.4991C137.483 90.1086 137.979 89.6096 138.761 89.6096C139.544 89.6096 141.971 89.0368 143.278 89.0368C144.585 89.0368 151.836 88.7975 150.616 89.6096Z",
    fill: "url(#paint20_linear_1727_32670)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.058 88.9191C152.058 88.9191 152.215 86.9523 152.215 86.3179C152.215 85.6835 146.952 86.5794 143.165 86.9349C142.754 88.5173 142.826 88.622 142.826 88.9191C142.826 89.0676 143.772 90.3406 148.861 89.9278C150.719 89.7772 152.058 88.9191 152.058 88.9191Z",
    fill: "#E1ECFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.17802,
    ry: 2.05174,
    transform: "matrix(-0.405466 -0.91411 -0.912978 0.408009 127.012 101.939)",
    fill: "#A1B8E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.083 96.4908L121.761 98.6898C121.761 98.6898 117.041 86.0477 116.755 84.407C116.468 82.7663 117.737 80.4509 117.942 79.6254C118.147 78.7999 118.114 76.8573 117.541 76.1465C116.968 75.4356 116.817 75.6895 116.389 75.5824C115.961 75.4752 113.421 70.0074 113.133 69.3204C112.845 68.6334 112.331 68.2024 111.809 68.4313C111.287 68.6602 111.335 69.2713 111.542 69.8117C111.748 70.3522 112.907 73.3852 112.775 73.9131C112.644 74.4411 110.604 75.1241 110.034 75.4747C109.465 75.8253 108.495 76.9781 108.98 78.6459C109.464 80.3136 111.701 83.3368 111.542 83.9798C111.382 84.6228 113.641 95.5186 114.36 99.8763C115.078 104.234 116.018 107.29 119.688 107.038C123.357 106.786 130.962 102.69 130.962 102.69C130.962 102.69 130.465 99.5085 129.515 98.3083C128.565 97.108 127.083 96.4908 127.083 96.4908Z",
    fill: "url(#paint21_linear_1727_32670)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1727_32670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 68,
    width: 23,
    height: 40
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.083 96.4908L121.761 98.6898C121.761 98.6898 117.041 86.0477 116.755 84.407C116.468 82.7663 117.737 80.4509 117.942 79.6254C118.147 78.7999 118.114 76.8573 117.541 76.1465C116.968 75.4356 116.817 75.6895 116.389 75.5824C115.961 75.4752 113.421 70.0074 113.133 69.3204C112.845 68.6334 112.331 68.2024 111.809 68.4313C111.287 68.6602 111.335 69.2713 111.542 69.8117C111.748 70.3522 112.907 73.3852 112.775 73.9131C112.644 74.4411 110.604 75.1241 110.034 75.4747C109.465 75.8253 108.495 76.9781 108.98 78.6459C109.464 80.3136 111.701 83.3368 111.542 83.9798C111.382 84.6228 113.641 95.5186 114.36 99.8763C115.078 104.234 116.018 107.29 119.688 107.038C123.357 106.786 130.962 102.69 130.962 102.69C130.962 102.69 130.465 99.5085 129.515 98.3083C128.565 97.108 127.083 96.4908 127.083 96.4908Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1727_32670)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.341 97.0763C125.341 97.0763 126.469 103.7 125.761 105.649C125.053 107.597 128.935 104.847 128.935 104.847C128.935 104.847 128.86 102.009 128.263 100.719C127.667 99.4294 125.341 97.0763 125.341 97.0763Z",
    fill: "#3D82F0",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M121.877 98.5332C121.577 98.6713 121.009 98.8862 120.5 99.5941",
    stroke: "#223762",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.995 106.726C128.396 103.716 127.532 99.5727 125.132 97.093C133.696 93.3864 136.395 92.0722 139.087 90.9178C141.779 89.7633 144.229 97.3675 139.087 101.15C133.945 104.933 130.424 106.093 128.995 106.726Z",
    fill: "url(#paint22_linear_1727_32670)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.194,
    cy: 29.4997,
    rx: 13.3013,
    ry: 13.5476,
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.195 14.4854C120.902 14.4854 114.18 21.208 114.18 29.5003C114.18 37.7927 120.902 44.5153 129.195 44.5153C137.487 44.5153 144.21 37.7927 144.21 29.5003C144.21 21.208 137.487 14.4854 129.195 14.4854ZM135.703 26.9615C135.823 26.8245 135.914 26.6649 135.971 26.4921C136.029 26.3194 136.051 26.1369 136.036 25.9554C136.022 25.774 135.972 25.5972 135.888 25.4356C135.804 25.2739 135.689 25.1306 135.55 25.0141C135.41 24.8975 135.248 24.8102 135.074 24.7571C134.9 24.704 134.717 24.6862 134.536 24.7049C134.355 24.7235 134.179 24.7782 134.02 24.8657C133.86 24.9532 133.72 25.0717 133.606 25.2143L127.737 32.2563L124.7 29.2178C124.442 28.9691 124.097 28.8316 123.74 28.8347C123.382 28.8378 123.039 28.9813 122.786 29.2344C122.533 29.4875 122.39 29.8299 122.387 30.1878C122.383 30.5457 122.521 30.8905 122.77 31.1479L126.865 35.2429C126.999 35.3769 127.159 35.4816 127.336 35.5501C127.513 35.6187 127.702 35.6496 127.891 35.641C128.081 35.6324 128.266 35.5844 128.436 35.5001C128.606 35.4158 128.757 35.2971 128.878 35.1514L135.703 26.9615Z",
    fill: "#29CC6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1727_32670",
    x: 94.9922,
    y: 24.585,
    width: 99.6641,
    height: 66.1377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788056 0 0 0 0 0.827193 0 0 0 0 0.89764 0 0 0 0.337126 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1727_32670"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1727_32670",
    x: 10.7305,
    y: -3.20996,
    width: 98.4766,
    height: 67.5771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788056 0 0 0 0 0.827193 0 0 0 0 0.89764 0 0 0 0.337126 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1727_32670"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1727_32670",
    x: -108.514,
    y: -127.309,
    width: 403.326,
    height: 438.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 81
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1727_32670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1727_32670",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1727_32670",
    x: 68.7402,
    y: 66.4648,
    width: 88.6992,
    height: 38.8203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 17,
    dy: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.706613 0 0 0 0 0.0893703 0 0 0 0.173347 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1727_32670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1727_32670",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1727_32670",
    x1: 128.406,
    y1: 83.8524,
    x2: 123.106,
    y2: 48.3382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1727_32670",
    x1: 43.8072,
    y1: 56.4231,
    x2: 38.356,
    y2: 20.6939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1727_32670",
    x1: 197.468,
    y1: 156.139,
    x2: 193.772,
    y2: 167.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1727_32670",
    x1: 114.596,
    y1: -20.3898,
    x2: 19.8991,
    y2: 2.48638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1727_32670",
    x1: 53.9592,
    y1: -51.4366,
    x2: -66.378,
    y2: 3.70489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1727_32670",
    x1: 7.16901,
    y1: 5.40069,
    x2: 67.5032,
    y2: 5.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1727_32670",
    x1: 10.7905,
    y1: 25.4204,
    x2: 22.5326,
    y2: 8.87929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#365383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1727_32670",
    x1: 91.8501,
    y1: 46.0482,
    x2: 89.6372,
    y2: 12.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1727_32670",
    x1: 91.8501,
    y1: 46.0482,
    x2: 89.6372,
    y2: 12.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1727_32670",
    x1: 91.8501,
    y1: 46.0482,
    x2: 89.6372,
    y2: 12.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1727_32670",
    x1: 108.965,
    y1: 31.4013,
    x2: 104.386,
    y2: -0.63388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECC4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1727_32670",
    x1: 158.676,
    y1: 124.822,
    x2: 154.146,
    y2: 117.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1727_32670",
    x1: 157.35,
    y1: 194.774,
    x2: 151.8,
    y2: 186.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1727_32670",
    x1: 123.272,
    y1: 198.332,
    x2: 118.794,
    y2: 189.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47689B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1727_32670",
    x1: 137.834,
    y1: 202.276,
    x2: 111.218,
    y2: 141.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1727_32670",
    x1: 125.348,
    y1: 132.182,
    x2: 125.636,
    y2: 127.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3",
    stopOpacity: 0.477723
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1727_32670",
    x1: 139.404,
    y1: 64.6315,
    x2: 149.055,
    y2: 71.1171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1727_32670",
    x1: 156.559,
    y1: 64.5394,
    x2: 147.895,
    y2: 75.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1727_32670",
    x1: 165.051,
    y1: 109.348,
    x2: 156.394,
    y2: 108.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1727_32670",
    x1: 132.776,
    y1: 118.976,
    x2: 127.012,
    y2: 115.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1727_32670",
    x1: 121.292,
    y1: 93.0349,
    x2: 121.372,
    y2: 87.6167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B8E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1727_32670",
    x1: 90.4986,
    y1: 124.754,
    x2: 103.276,
    y2: 73.6968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70B8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D82F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1727_32670",
    x1: 144.802,
    y1: 95.5595,
    x2: 139.05,
    y2: 107.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3EDFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_32670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterMobile);
export default __webpack_public_path__ + "static/media/register-mobile.d2d85271f27ffadb3e86cee1bfd84ae7.svg";
export { ForwardRef as ReactComponent };